import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components/ui/table";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";

// Helper function to format Indian numbers
const formatIndianNumber = (num) => {
  if (num === undefined || num === null) return '';
  num = Number(num);
  if (Math.abs(num) >= 1e7) return (num / 1e7).toFixed(2) + ' Cr';
  if (Math.abs(num) >= 1e5) return (num / 1e5).toFixed(2) + ' L';
  return num.toLocaleString('en-IN');
};

// Helper function to format percentage
const formatPercentage = (value) => {
  if (value === undefined || value === null) return '0%';
  return `${Number(value).toFixed(2)}%`;
};

export function SourceWisePnlTable({ data = [] }) {
  return (
    <Card className="mt-6">
      <CardHeader>
        <CardTitle>Source-wise PNL</CardTitle>
        <CardDescription>
          Detailed PNL metrics for each source
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="mt-4 overflow-auto custom-scroll max-h-[480px]">
          <Table>
            <TableHeader className="bg-muted sticky top-0 z-10">
              <TableRow>
                <TableHead className="text-left py-4 text-[12px]">Source Name</TableHead>
                <TableHead className="text-right py-4 text-[12px]">Total PNL</TableHead>
                <TableHead className="text-right py-4 text-[12px]">Trades</TableHead>
                <TableHead className="text-right py-4 text-[12px]">Accuracy</TableHead>
                <TableHead className="text-right py-4 text-[12px]">Avg Win</TableHead>
                <TableHead className="text-right py-4 text-[12px]">Avg Loss</TableHead>
                <TableHead className="text-right py-4 text-[12px]">Avg Win (%)</TableHead>
                <TableHead className="text-right py-4 text-[12px]">Avg Loss (%)</TableHead>
                <TableHead className="text-right py-4 text-[12px]">Expectancy</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {data.map((row, index) => (
                <TableRow key={index}>
                  <TableCell className="text-left py-4">{row.source_name}</TableCell>
                  <TableCell className={`text-right py-4 ${row.total_pnl > 0 ? 'text-teal-400' : 'text-rose-400'}`}>
                    {formatIndianNumber(row.total_pnl)}
                  </TableCell>
                  <TableCell className="text-right py-4">{row.trades}</TableCell>
                  <TableCell className="text-right py-4">
                    {formatPercentage(row.accuracy)}
                  </TableCell>
                  <TableCell className={`text-right py-4 ${row.avg_win > 0 ? 'text-teal-400' : 'text-rose-400'}`}>
                    {formatIndianNumber(row.avg_win)}
                  </TableCell>
                  <TableCell className={`text-right py-4 ${row.avg_loss > 0 ? 'text-teal-400' : 'text-rose-400'}`}>
                    {formatIndianNumber(row.avg_loss)}
                  </TableCell>
                  <TableCell className={`text-right py-4 ${row.avg_win_percent > 0 ? 'text-teal-400' : 'text-rose-400'}`}>
                    {formatPercentage(row.avg_win_percent)}
                  </TableCell>
                  <TableCell className={`text-right py-4 ${row.avg_loss_percent > 0 ? 'text-teal-400' : 'text-rose-400'}`}>
                    {formatPercentage(row.avg_loss_percent)}
                  </TableCell>
                  <TableCell className={`text-right py-4 ${row.expectancy > 0 ? 'text-teal-400' : 'text-rose-400'}`}>
                    {formatIndianNumber(row.expectancy)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </Card>
  );
}
